namespace Portico.Services {
    import ps = Portico.Services;
    import pme = Portico.Models.Enterprise;
	import gateway = Portico.Models.Gateway;
	import psga = apigateway.client;
	import psgm = apigateway.models;
    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

    export interface IHubService {
		getAccount(accountId: number): angular.IPromise<pme.Account>;
		getPatient(patientId: string): angular.IPromise<pme.Patient>;
		savePatient(patient: pme.Patient): angular.IPromise<string>;
		searchAccounts(patient: pme.Patient): angular.IPromise<pme.Account[]>;
		searchPatients(patient: pme.Patient): angular.IPromise<pme.Patient[]>;
    }

    @Service('app', 'hubService')
	@Inject('$q', 'EdgeHubApi')
    export class HubService implements IHubService {
        constructor(
			private $q: angular.IQService,
			private edgeHubApi: psga.EdgeHubApi
        ){}

		getAccount(accountId: number) {
			return this.$q.when(this.edgeHubApi.hubV1GetAccount({ accountId: accountId }).then(response => {
				response.data.data.account.lastModifiedTime = <moment.Moment><unknown>response.data.data.account.lastModifiedTime?.toDate();
				response.data.data.patient.dateOfBirth = <moment.Moment><unknown>response.data.data.patient.dateOfBirth?.toDate();
				const account = new pme.Account(response.data.data.account);
				account.patient = new pme.Patient(response.data.data.patient);
				return account;
			}));
		}

		getPatient(patientId: string) {
			return this.$q.when(this.edgeHubApi.hubV1GetPatient({ patientId: patientId }).then(response => {
				response.data.data.dateOfBirth = <moment.Moment><unknown>response.data.data.dateOfBirth?.toDate();
				return new pme.Patient(response.data.data);
			}));
		}

		savePatient(patient: pme.Patient) {
			const request: psgm.SavePatientRequestModel = {				
				patientUpsearchModel: <psgm.PatientUpsearchModel> patient.mapToEnterpriseCoordinatorPatientUpsearchModelWithFlags(true, true, false)
			};

			return this.$q.when(this.edgeHubApi.hubV1SavePatient(request).then(response => {
				return response.data.data.patientId;
			}));
		}

		searchAccounts(patient: pme.Patient) {
			const request = {
				firstName: patient.firstName,
				lastName: patient.lastName,
				dateOfBirth: moment(patient.dateOfBirth),
				gender: Portico.Models.Gateway.Gender[patient.gender],
				city: _.get(patient, 'addresses[0].city', ''),
				state: _.get(patient, 'addresses[0].state', ''),
				zip: _.get(patient, 'addresses[0].zip', '')
			};

			return this.$q.when(this.edgeHubApi.hubV1SearchAccounts(request).then(response => {
				return response.data.data.map((r) => {
					const account = new pme.Account(r.account);
					account.patient = new pme.Patient(r.patient);
					account.patient.ssn = r.ssn;
					return account;
				});
			}));
		}

		searchAccountsWithExternalId(patient: pme.Patient, externalId: string, accountExternalIdType: gateway.AccountExternalIdType ) {
			const request = {
				firstName: patient.firstName,
				lastName: patient.lastName,
				dateOfBirth: moment(patient.dateOfBirth),
				gender: gateway.Gender[patient.gender],
				city: _.get(patient, 'addresses[0].city', ''),
				state: _.get(patient, 'addresses[0].state', ''),
				zip: _.get(patient, 'addresses[0].zip', ''),
				externalId,
				accountExternalIdType
			};

			return this.$q.when(this.edgeHubApi.hubV1SearchAccounts(request).then(response => {
				return response.data.data.map((r) => {
					r.account.lastModifiedTime = <moment.Moment><unknown>r.account.lastModifiedTime?.toDate();
					r.patient.dateOfBirth = <moment.Moment><unknown>r.patient.dateOfBirth?.toDate();
					const account = new pme.Account(r.account);
					account.patient = new pme.Patient(r.patient);
					account.patient.ssn = r.ssn;
					return account;
				});
			}));
		}

		searchPatients(patient: pme.Patient) {
			const request = {
				firstName: patient.firstName,
				lastName: patient.lastName,
				dateOfBirth: moment(patient.dateOfBirth),
				addressOne: _.get(patient, 'addresses[0].addressOne', ''),
				city: _.get(patient, 'addresses[0].city', ''),
				state: _.get(patient, 'addresses[0].state', ''),
				zip: _.get(patient, 'addresses[0].zip', '')
			};

			return this.$q.when(this.edgeHubApi.hubV1SearchPatients(request).then(response => {
				return response.data.data.map((r) => {
					r.dateOfBirth = <moment.Moment><unknown>r.dateOfBirth?.toDate();
					return new pme.Patient(r);
				});
			}));
		}
    }
}